<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <form @submit.prevent="submit">
      <div class="modal-card">
        <header class="modal-card-head">
          <h1 class="is-title-header modal-card-title">
            {{ item.preset_scenario_name }}
          </h1>
        </header>
        <section class="modal-card-body">
          <div class="columns is-multiline">
            <div class="column">
              <b-field label="Playground Name">
                <b-input
                  required
                  placeholder="Type a name for Playground"
                  v-model="formData.playground_name"
                ></b-input>
              </b-field>
              <b-field label="Period">
                <b-input
                  required
                  v-model="formData.period"
                  placeholder="Type a valid Period. Example: 2024-CY"
                ></b-input>
              </b-field>
            </div>
          </div>
          <!-- <div class="columns">
          <div class="column">
            <b-field label="Valid From">
              <b-datepicker
                name="valid_from"
                v-model="formData.valid_from"
                icon="calendar-today"
                trap-focus
                :date-formatter="dateFormatter"
              >
                <b-button type="is-danger" @click="formData.valid_from = null">
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Valid To">
              <b-datepicker
                name="valid_to"
                v-model="formData.valid_to"
                icon="calendar-today"
                trap-focus
                :date-formatter="dateFormatter"
              >
                <b-button type="is-danger" @click="formData.valid_to = null">
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
          </div>
        </div> -->
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
          <div class="control is-2"></div>
          <div class="is-10">
            <button class="button is-normal" @click="cancel">Cancel</button>
            <button
              class="button is-primary"
              native-type="submit"
              type="is-primary"
            >
              Create New Playground
              <b-icon icon="chevron-right" class="icon-margin-left"></b-icon>
            </button>
          </div>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
//import Multiselect from "vue-multiselect";

export default {
  name: "SelectUrgencyModal",
  mixins: [UtilityMixin, scopeMixin],
  components: {
    // Multiselect
  },

  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    item: {}
  },

  data() {
    return {
      isModalActive: false,
      formData: {
        valid_from: null,
        valid_to: null,
        period: null,
        name: null,
        preset_scenario: null,
        top_metric: null
      }
    };
  },

  methods: {
    dateFormatter(dt) {
      if (dt != null) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },
    cancel() {
      this.disableOKButton = true;
      this.$emit("cancel");
    },
    submit() {
      this.$emit("confirm", this.formData);
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
      this.formData = {
        valid_from: null,
        valid_to: null,
        period: null,
        name: null,
        preset_scenario: null,
        top_metric: null
      };
    }
  }
};
</script>

<style scoped>
.icon-margin-left {
  margin-left: 8px !important; /* Adjust the margin as needed */
}
</style>
